import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NDDTranslationModule } from '@ndk/ng-translation';

import { HelpMenuContentComponent } from './content/help-menu.content.component';
import { HelpMenuService } from './shared/help-menu.service';

@NgModule({
    imports: [
        CommonModule,
        NDDTranslationModule,
    ],
    exports: [
        HelpMenuContentComponent,
    ],
    declarations: [
        HelpMenuContentComponent,
    ],
    providers: [
        HelpMenuService,
    ],
})
export class HelpMenuModule { }
